export const MODAL_SHOWED = "MODAL_SHOWED";
export const MODAL_HIDE = "MODAL_HIDE";
